/**
 * Initialize the global navigate function This should be called from a React component that has access to useNavigate
 */
export const setGlobalNavigate = navigateFunction => {
	window._navigate = navigateFunction
}

/**
 * Navigate to a path using React Router Falls back to window.location.href if navigate function is not available
 */
export const navigateTo = path => {
	window._navigate(path)
}

/**
 * Navigate back using React Router
 */
export const navigateBack = () => {
	if (window._navigate) {
		window._navigate(-1)
	} else {
		window.history.back()
	}
}

export default {
	setGlobalNavigate,
	navigateTo,
	navigateBack,
}
